module.exports = __webpack_public_path__ + "img/jigouruzhu-2.a13dc40f.svg";